module.exports = __webpack_public_path__ + "assets/images/project/banner_image_blueneutral-desktop.jpg?v=40ef5533";